import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar'; // Assure-toi que les imports correspondent à tes fichiers
import Home from './pages/Home';
import Tools from './pages/Tools';
import Projects from './pages/Projects';
import Watch from './pages/Watch';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white dark:bg-[#050505] text-gray-900 dark:text-gray-100 transition-colors font-sans">
        <Navbar />
        
        {/* Le contenu change ici dynamiquement */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projets" element={<Projects />} />
          <Route path="/outils" element={<Tools />} />
          <Route path="/veille" element={<Watch />} />
        </Routes>

        <footer className="py-10 text-center text-sm opacity-50 border-t border-gray-100 dark:border-white/5 mt-auto">
           <p>© 2026 Anis Lafrad. Portfolio React & Tailwind.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;